import * as React from 'react';
import { InputNumberRange as InputNumberRangeComponent } from '../../components/InputNumberRange';
import { TNumberInputs } from '../../types/filters';
import { TInputSize } from '../../types/inputSize';

interface IInputNumberRangeProps {
  title?: string;
  min: TNumberInputs;
  max: TNumberInputs;
  onChange: (type: 'min' | 'max') => (e: React.SyntheticEvent, value: string) => void;
  rightAdornment?: string;
  size?: TInputSize;
}

export function InputNumberRange({ min, max, title, onChange, rightAdornment, size = 'XS' }: IInputNumberRangeProps) {
  const [error, setError] = React.useState(false);

  const handleBlur = React.useCallback(() => {
    /* istanbul ignore next */
    if (!!min && !!max) {
      setError(Boolean(min > max));
    }
  }, [max, min]);

  return (
    <InputNumberRangeComponent
      size={size}
      title={title}
      min={min}
      max={max}
      onChange={onChange}
      rightAdornment={rightAdornment}
      onBlur={handleBlur}
      error={error}
    />
  );
}
